export const analyzeWorkflows = [
    { label: 'Standard', value: 'Analysis' },
    { label: 'Version 2', value: 'Analysis2' },
    { label: 'Version 3', value: 'Analysis3' }
  ] as const;
  
  export const shortenWorkflows = [
    { label: 'Standard', value: 'Shortener' },
  ] as const;
  
  export const fixingWorkflows = [
    { label: 'Standard', value: 'Fixer' },
  ] as const;
  
  export type AnalyzeWorkflowType = typeof analyzeWorkflows[number]['value'];
  export type ShortenWorkflowType = typeof shortenWorkflows[number]['value'];
  export type FixingWorkflowType = typeof fixingWorkflows[number]['value'];